import axios from 'axios';
import {
  SERVER_ERROR_KEY,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';



import httpErrors, { HttpError } from 'http-errors';
import { LiveEventByIdInput } from '../input-schemas/playback-api-input-schema';
import { LiveEventByIdResponse } from '../response-schemas/live-event-by-id-response';
import { getAuthToken, getHeader } from '../utils/queries-utils';
export const LiveEventByIdQuery = async ({
  input,
}: {
  input: LiveEventByIdInput;
}) => {
  try {
    const { streamId, isAuthenticated, refreshToken, accessToken, idToken, config } = input;

    const { url, xApiKey, realm } = config;

    const authTokenResponse = await getAuthToken({isAuthenticated,
      refreshToken,
      accessToken,
      idToken,
      config});
    const result = await axios
      .get(`${url}/api/v4/event/${streamId}`,
        getHeader(xApiKey, realm, authTokenResponse))
      .then(handleAxiosResponse)
      .catch(handleError);

    if (result.hasErrors) {
      const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
        result?.errorMessages?.join('\n'),
      ) as HttpError;
      err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
      throw err;
    }

    return result.data as LiveEventByIdResponse;
  } catch (err: any) {
    console.error(`Error on Live Event By Id Query: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};
